export const wait = async (ms: number): Promise<void> => {
  return new Promise(resolve => {
    console.log("wait");
    setTimeout(resolve, ms);
  });
};
